import urls from 'urls';
import {useScript} from '~/common/hooks/useScript';
import {Button} from '~library/atoms/Button';

const SESAME_UUID = '8a18be44-1e17-447f-9e0d-dd289b90c619';
const SESAME_FEATURED_COPY =
  'Join Evite in supporting Sesame Workshop in helping kids everywhere grow smarter, stronger, and kinder.';

export const Pledgeling = (props) => {
  const {
    pledgeKey,
    pledgelingId,
    pledgelingGoal,
    pledgelingPurpose,
    eventType,
    onClick,
    disabled,
    isSesame,
    pledgeUrl,
    pledgeType,
    dataQaId,
    buttonText = 'Save',
  } = props;

  const isScriptLoaded = useScript(urls.get('pledge_url', {pledgeDomain: pledgeUrl}), {
    id: 'pledgeSdkId',
  });
  if (!isScriptLoaded) return null;

  if (pledgeType === 'charity-donation') {
    return (
      <>
        <div className="create-flow__overlay-form gifting__overlay__body__content">
          {/** Charity Donation Sidebar */}
          <div
            className="plg-search"
            data-partner-key={pledgeKey}
            data-organization-id={pledgelingId}
            data-goal={pledgelingGoal}
            data-event-type={eventType}
            data-template="branding-2025"
            data-featured-uuid={isSesame ? SESAME_UUID : undefined}
            data-featured-copy={isSesame ? SESAME_FEATURED_COPY : undefined}
          />
        </div>
        <Button
          data-qa-id={dataQaId}
          className="create-flow__overlay-save-button"
          variant="primary"
          size="large"
          disabled={disabled}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </>
    );
  }
  if (pledgeType === 'crowd-funding') {
    return (
      <>
        <div className="create-flow__overlay-form gifting__overlay__body__content">
          {/** Crowd Funding Sidebar */}
          <div
            className="plg-crowd"
            data-partner-key={pledgeKey}
            data-purpose={pledgelingPurpose}
            data-goal={pledgelingGoal}
            data-event-type={eventType}
            data-template="branding-2025"
          />
        </div>
        <Button
          data-qa-id={dataQaId}
          className="create-flow__overlay-save-button"
          variant="primary"
          size="large"
          disabled={disabled}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </>
    );
  }
  evite.error(`Unknown pledge type: ${pledgeType}`);
  return null;
};
